import { useQuery, type QueryHookOptions } from "@apollo/client"
import query from "@/v2-backoffice-client/user/tenant/type/user.tenant.type.query.gql"
import type {
  UserTenantTypeQuery,
  UserTenantTypeQueryVariables,
} from "@/v2-backoffice-client/user/tenant/type/__types__/user.tenant.type.query"

type Options = QueryHookOptions<
  UserTenantTypeQuery,
  UserTenantTypeQueryVariables
>

export function useUserTenantTypeQuery(options?: Options) {
  return useQuery<UserTenantTypeQuery, UserTenantTypeQueryVariables>(
    query,
    options,
  )
}
